import { SharedModule } from '$shared/shared.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MainSearchComponent } from './main-search.component';

@NgModule({
  declarations: [MainSearchComponent],
  imports: [CommonModule, SharedModule],
  exports: [MainSearchComponent],
})
export class MainSearchModule {}
